import { v4 as uuidv4 } from 'uuid';
import { updatePosthogSession } from './analytics';

export const SESSION_ID_KEY = 'alfinder_session_id';

export const getSessionId = () => {
  return localStorage.getItem(SESSION_ID_KEY);
};

export const getOrCreateSessionId = () => {
  const currentSessionId = localStorage.getItem(SESSION_ID_KEY);

  if (currentSessionId) {
    return currentSessionId;
  }

  // Create new session if none exists
  const newSessionId = uuidv4();
  localStorage.setItem(SESSION_ID_KEY, newSessionId);
  updatePosthogSession(newSessionId);
  return newSessionId;
};
